//
//
//
//

export default {
  name: 'rb-algolia-featured-products',
  props: {
    groupedRule: {
      type: String,
      default: '',
    },
    ungroupedRule: {
      type: String,
      default: '',
    },
    maxNumber: {
      type: Number,
      default: 3,
    },
    internalContent: {
      type: Boolean,
      default: false,
    },
    isCluster: {
      type: Boolean,
      default: true,
    },
    dataElementId: {
      type: String,
      default: '',
    },
    wishlistIconIsVisible: {
      type: Boolean,
      default: true,
    },
  },
}
